import angular from 'angular';
import Directives from './directives/directives';
import FieldValidators from './field-validators/field-validators';
import Filters from './filters/filters';
import Services from './services/services';
import Shell from './layout/shell/shell';
import Sidenav from './layout/sidenav/sidenav';
import Toolbar from './layout/toolbar/toolbar';
import User from './user/user';

let commonModule = angular.module('app.common', [
  Directives,
  FieldValidators,
  Filters,
  Services,
  Shell,
  Sidenav,
  Toolbar,
  User
])

.name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js